module.exports = __webpack_public_path__ + "img/abm.82cebad1.png";